import React, { useState,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useHeader } from "../../../../context/HeaderContext";
import BottomMenu from "../../../../components/Dashboard/BottomMenu";
import { useGetPaymentInfoQuery, useSubmitPremiumPaymentProofMutation, useSubmitPremiumPlusPaymentProofMutation } from "../../../../services/addMoneyApi";
import { IoCopyOutline, IoWarningOutline, IoAlertCircle } from "react-icons/io5";
import { Notification } from "../../../../components/ToastNotification";
import InlineRefreshIndicator from "../../../../components/InlineRefreshIndicator";
import "./paymentMethods.css";
import { useGetSpecificUserPremium_PlusAmountQuery } from "../../../../services/userApi";

const PremiumGPayTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { amount } = location.state || {};
//  const { setScreenName } = useHeader();
//    useEffect(() => {
//        setScreenName("Gpay Details");
//        return () => {
//          setScreenName(null);
//        };
//      }, []);
  const [transactionId, setTransactionId] = useState("");
  const [singleFile, setSingleFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);

  const { data: paymentInfo, isLoading: paymentInfoLoading } = useGetPaymentInfoQuery();
  const [submitPremiumPaymentProof] = useSubmitPremiumPaymentProofMutation();

  const handleSubmit = async () => {
    if (singleFile) {
      try {
        setFileUploading(true);
        const formData = new FormData();
        formData.append("file", singleFile);
        formData.append("transactionId", transactionId);
        formData.append("payment_mode", "gpay_payment");

        const response = await submitPremiumPaymentProof(formData);

        if (response.error) {
          Notification(response.error.data.message, "error");
        } else {
          Notification(`Request for Premium plan sent successfully`, "success");
          setTransactionId("");
          setSingleFile(null);
        }
      } catch (error) {
        console.error("Error details:", error);
        Notification("An error occurred during submission", "error");
      } finally {
        setFileUploading(false);
      }
    } else {
      Notification("Payment proof image is required", "error");
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Notification("GPay Number Copied", "success");
  };

  const selectFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 3 * 1024 * 1024) {
      alert("Maximum size of images is 3 MB");
    } else {
      setSingleFile(file);
    }
  };

  return (
    // <div className="tpu__premium__wrapper layoutContainer">
      <div className="layoutContainer">
        <div className="tpu__premium__section__area">
          <div className="tpu-premium-upi-scroll-view">
            <div className="tpu-premium-upi-content">
              {/* GPay Number Card */}
              <div className="tpu-premium-upi-card">
                <div className="tpu-premium-upi-card-row">
                  <p className="tpu-premium-upi-card-label">GPay Number:</p>
                  <IoCopyOutline
                    size={18}
                    color={"#007aff"}
                    style={{ cursor: "pointer", marginTop: "2px" }}
                    onClick={() =>
                      copyToClipboard(
                        paymentInfo?.data?.data?.payment_info[0][3]?.gpay_info?.gpay || ""
                      )
                    }
                  />
                </div>
                <p className="tpu-premium-upi-card-value">
                  {paymentInfo?.data?.data?.payment_info[0][3]?.gpay_info?.gpay || "N/A"}
                </p>
              </div>

              {/* Amount Input (readonly) */}
              <div className="tpu-premium-upi-input-container">
                <label className="tpu-premium-upi-label">Amount (INR)</label>
                <input
                  className="tpu-premium-upi-input disabled-input"
                  value={amount ? amount.toString() : ""}
                  readOnly
                />
              </div>

              {/* Transaction ID Input */}
              <div className="tpu-premium-upi-input-container">
                <label className="tpu-premium-upi-label">Transaction ID</label>
                <input
                  className="tpu-premium-upi-input"
                  value={transactionId}
                  onChange={(e) => setTransactionId(e.target.value)}
                  placeholder="Enter transaction id"
                />
              </div>

              {/* Upload File */}
              <div className="tpu-premium-upi-input-container">
                <label className="tpu-premium-upi-label">Upload File</label>
                <button
                  className="file-picker-btn"
                  onClick={() => document.getElementById("upload-file").click()}
                >
                  <input
                    type="file"
                    id="upload-file"
                    onChange={selectFile}
                    style={{ display: "none" }}
                  />
                  <span>
                    {singleFile?.name ? singleFile.name.slice(0, 15) : "Choose File"}
                  </span>
                </button>
              </div>

              {/* Preview Uploaded File */}
              {singleFile && (
                <div className="file-preview">
                  <img
                    src={URL.createObjectURL(singleFile)}
                    alt="File preview"
                    className="file-preview__image"
                  />
                  <div className="file-preview__info">
                    <span>{singleFile?.name}</span>
                  </div>
                </div>
              )}

              {/* Submit Buttons */}
              <div className="tpu-premium-upi-button-container">
                <button
                  className="tpu-premium-upi-button prev"
                  onClick={() => navigate(-1)}
                >
                  Prev
                </button>
                <button
                  className={`tpu-premium-upi-button submit ${
                    !transactionId || !singleFile || fileUploading ? "disabled" : ""
                  }`}
                  disabled={!transactionId || !singleFile || fileUploading}
                  onClick={handleSubmit}
                >
                  {fileUploading ? "Uploading..." : "Submit"}
                </button>
              </div>

              {/* Disclaimer */}
              <div className="disclaimer-container">
                <div className="disclaimer-gradient">
                  <div className="disclaimer-header">
                    <IoWarningOutline className="warning-icon" />
                    <span className="disclaimer-title">Disclaimer</span>
                  </div>
                  <div className="disclaimer-content">
                    <div className="disclaimer-item">
                      <div className="bullet-container">
                        <IoAlertCircle className="alert-icon" />
                      </div>
                      <span className="disclaimer-text">
                        Ensure you are sending to the correct GPay number.
                      </span>
                    </div>
                    <div className="disclaimer-item">
                      <div className="bullet-container">
                        <IoAlertCircle className="alert-icon" />
                      </div>
                      <span className="disclaimer-text">
                        Enter the correct transaction ID for faster verification.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Disclaimer */}
            </div>
          </div>
        </div>
        {/* <BottomMenu /> */}
      </div>
    // </div>
  );
};

export default PremiumGPayTransfer;
